module.exports = __webpack_public_path__ + "static/media/temp_w_domu_chlodzenie_1.65732190.svg";